import { render, staticRenderFns } from "./types_of_transport.vue?vue&type=template&id=f6816ae8"
import script from "./types_of_transport.vue?vue&type=script&lang=js"
export * from "./types_of_transport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports